/* eslint-disable no-shadow */

enum EnumQuestionType {
  Scale = 'Scale',
  SelectOne = 'Select One',
  SelectMultiple = 'Select Multiple',
  Text = 'Text',
}

export default EnumQuestionType;
